//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    skuPrefix: { type: String, required: true },
    sku: { type: String, required: true },
    baseSku: { type: String, required: true },
    frameType: { type: String, default: null },
    productDetails: { type: Object, default: null },
    techSpecs: { type: Array, required: true }
  },
  computed: {
    visibleTechSpecs () {
      return this.techSpecs.filter(spec => (this.lensTech || '').match(spec.lensTechFilter || '.*'))
    },
    lensTech () {
      return this.$store.getters['product/lensTech'](this.sku)
    }
  }
}
